import { useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Drawer, Box, List } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoutIcon from "@mui/icons-material/Logout";
import HomeIcon from "@mui/icons-material/Home";

import { logout } from "../utils/loginUtils";
import { Role } from "../types/user";
import { menus } from "../utils/menu";

const MobileDrawer = ({ role }: { role: Role }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const currentTab = useMemo(
    () => menus[role].find((menu) => pathname.includes(menu.path)),
    [pathname, role]
  );

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const isHome = useMemo(() => {
    const parsedPath = pathname.split("/");
    return parsedPath[parsedPath.length - 1] === role;
  }, [pathname, role]);

  const DrawerList = (
    <Box role="presentation" onClick={toggleDrawer(false)}>
      <div id="drawer-login-info">
        <p>한양대학교 스포츠지도사 연수원</p>
        <div className="horizontal space-between">
          <span>
            <b style={{ fontSize: "20px" }}>{sessionStorage.getItem("name")}</b>
            님
          </span>
          <div className="horizontal">
            {!isHome && (
              <HomeIcon
                onClick={() => {
                  toggleDrawer(false);
                  navigate(`/${role}`);
                }}
              />
            )}
            <LogoutIcon onClick={logout} />
          </div>
        </div>
      </div>
      {!isHome && (
        <List>
          {menus[role].map((menu) => (
            <Link key={menu.path} to={menu.path} className="nav-menu">
              <img src={menu.icon} alt={menu.tabName} />
              <p>{menu.tabName}</p>
            </Link>
          ))}
        </List>
      )}
    </Box>
  );

  return (
    <div id="header">
      <MenuIcon onClick={toggleDrawer(true)} />
      <span>{currentTab?.tabName}</span>
      <Drawer open={open} onClose={toggleDrawer(false)}>
        {DrawerList}
      </Drawer>
    </div>
  );
};

export default MobileDrawer;
